import React, { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import CustomAudioVideoControls from "./CustomAudioVideoControls";

const CustomAudioPlayer = () => {
  const [searchParams] = useSearchParams();
  const url = searchParams.get("url");
  const time = searchParams.get("t") || "";
  const audioUrl = `${url}${time ? `#t=${time}` : ""}`;
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(time || 0);
  const [duration, setDuration] = useState(0);
  const [seeking, setIsSeeking] = useState(false);

  useEffect(() => {
    // Duration is tied to a useEffect so that the media and duration are available when the component mounts
    const audioElement = audioRef.current;
    const handleLoadedMetadata = () => {
      setDuration(audioElement.duration);
    };
    function attachListeners() {
      audioElement.addEventListener("loadedmetadata", handleLoadedMetadata);
    }
    if (!audioElement) {
      // If no audio yet, wait for it to appear in the DOM
      const intervalId = setInterval(() => {
        if (audioElement) {
          clearInterval(intervalId);
          attachListeners();
        }
      }, 100);
    } else {
      attachListeners();
    }
    //audioElement.addEventListener("loadedmetadata", handleLoadedMetadata);
    return () => {
      audioElement.removeEventListener("loadedmetadata", handleLoadedMetadata);
    };
  }, []);

  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  return (
    <div className="flex items-center justify-center">
      <div className="relative w-full h-full">
        <audio
          ref={audioRef}
          src={audioUrl}
          id="audioPlayer"
          preload="metadata"
          onTimeUpdate={() => {
            // Updating while dragging is handled in the handleSeeking function
            if (!seeking) {
              handleTimeUpdate();
            }
          }}
          onPlaying={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
        />
        <div className="flex items-center bg-primaryDark text-white  flex-col w-full min-h-[140px] sm:min-h-max sm:flex-row p-4 rounded-xl gap-7 p-4 mt-[-1px]">
          <CustomAudioVideoControls
            mediaRef={audioRef}
            mediaUrl={audioUrl}
            isPlaying={isPlaying}
            currentTime={currentTime}
            setCurrentTime={setCurrentTime}
            duration={duration}
            seeking={seeking}
            setIsSeeking={setIsSeeking}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomAudioPlayer;
